import { http, HttpResponse } from "msw";
import { BASE_URL, CLIENT_IDS, isClient } from "../constants";
import { loadMock } from "../utils";

const giftCardHandlers = [
  http.post(`${BASE_URL}/v1.0/Category`, async ({ request }) => {
    if (!isClient(request, CLIENT_IDS.giftCards)) return;
    return HttpResponse.json(await loadMock("GiftCards/categories"));
  }),
];

export { giftCardHandlers };
